<template>
  <div>

    <!-- ── Stat Tiles ──────────────────────────────────────────── -->
    <div class="row mb-2 stat-tiles">

      <div class="col-lg-4 col-md-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Basic Healthcare Provision Fund</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.bhcpf | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <div class="card border-0 shadow-sm h-100 sep-card" @click="openSepBreakdown">
          <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
            <div class="avatar avatar-md flex-shrink-0">
              <div class="avatar-title bg-soft-dark rounded-circle text-dark">
                <i class="fe fe-users"></i>
              </div>
            </div>
            <div class="flex-grow-1">
              <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">State Equity Program</p>
              <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.sep | numeral(0, 0) }}</h4>
            </div>
            <i class="fe fe-chevron-down text-muted"></i>
          </div>
        </div>
      </div>

      <div class="col-lg-4 col-md-6 mb-4">
        <router-link :to="{ path: '/plans' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-secondary rounded-circle text-secondary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Voluntary Contributor</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.voluntary + informaldata.dependants | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-6 mb-4">
        <router-link :to="{ path: '/my-providers' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-info rounded-circle text-info">
                  <i class="fe fe-activity"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Health Facilities</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.providers }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-6 mb-4">
        <router-link :to="{ path: '/all-claims' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-warning rounded-circle text-warning">
                  <i class="fe fe-credit-card"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Claims</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.claims | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-6 mb-4">
        <router-link :to="{ path: '/list-records' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-success rounded-circle text-success">
                  <i class="fe fe-file-plus"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">All Encounters</p>
                <h4 class="mb-0 font-weight-bold text-dark">{{ informaldata.encounters | numeral(0, 0) }}</h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

      <div class="col-lg-3 col-md-6 mb-4">
        <router-link :to="{ path: '/view-clients-agency' }" class="text-decoration-none">
          <div class="card border-0 shadow-sm h-100" style="border-left: 3px solid #2563eb !important;">
            <div class="card-body py-3 px-4 d-flex align-items-center" style="gap: 14px;">
              <div class="avatar avatar-md flex-shrink-0">
                <div class="avatar-title bg-soft-primary rounded-circle text-primary">
                  <i class="fe fe-users"></i>
                </div>
              </div>
              <div>
                <p class="mb-0 text-muted" style="font-size: .72rem; text-transform: uppercase; letter-spacing: .04em;">Total Informal Enrollees</p>
                <h4 class="mb-0 font-weight-bold text-primary">
                  {{ informaldata.bhcpf + informaldata.sep + informaldata.voluntary + informaldata.dependants | numeral(0, 0) }}
                </h4>
              </div>
            </div>
          </div>
        </router-link>
      </div>

    </div>

    <!-- ── Quick Links ────────────────────────────────────────────── -->
    <div class="d-flex mb-4" style="gap: 8px;">
      <router-link to="export-date">
        <button class="btn btn-sm btn-outline-secondary">
          <i class="fe fe-calendar mr-1"></i> Filter Enrollee Date
        </button>
      </router-link>
      <router-link to="export-provider">
        <button class="btn btn-sm btn-outline-secondary">
          <i class="fe fe-filter mr-1"></i> Filter Enrollee Provider
        </button>
      </router-link>
    </div>

    <!-- ── Charts ─────────────────────────────────────────────────── -->
    <div class="mb-4">
      <informalLga />
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-bar-chart-2 text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Gender Distribution by LGA</h6>
      </div>
      <div class="card-body pt-0">
        <GenderbyLGA :sectors="sectors" />
      </div>
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-users text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Enrollee Distribution by Vulnerable Group</h6>
      </div>
      <div class="card-body pt-0">
        <VulnerableByLGA />
      </div>
    </div>

    <div class="card shadow table-card mb-4">
      <div class="d-flex align-items-center px-4 pt-4 pb-3">
        <i class="fe fe-map-pin text-primary mr-2"></i>
        <h6 class="mb-0 font-weight-bold">Enrollee Distribution by LGA and Facility</h6>
      </div>
      <div class="card-body pt-0">
        <EnrolleebyLGAandFacility />
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-6">
        <ChartAboveAndBelow18 />
      </div>
    </div>

    <h6 class="font-weight-bold mb-3">
      <i class="fe fe-activity text-primary mr-2"></i> Category of Vulnerable Group Data
    </h6>
    <div class="row mb-4">
      <div class="col-md-6 mb-4">
        <BasicCategory />
      </div>
      <div class="col-md-6 mb-4">
        <genderCategory />
      </div>
    </div>

    <!-- ── State Equity Program Breakdown ────────────────────────────── -->
    <div class="sep-modal-overlay" v-if="sepBreakdown.open" @click.self="closeSepBreakdown">
      <div class="sep-modal card shadow">
        <div class="d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
          <h6 class="mb-0 font-weight-bold">State Equity Program — Breakdown</h6>
          <button type="button" class="btn btn-sm btn-outline-secondary" @click="closeSepBreakdown">
            <i class="fe fe-x"></i>
          </button>
        </div>
        <div class="px-4 py-3">
          <div v-if="sepBreakdown.loading" class="text-center text-muted py-4">
            <i class="fe fe-loader"></i> Loading breakdown…
          </div>
          <div v-else-if="!sepBreakdown.rows.length" class="text-center text-muted py-4">
            No breakdown data available
          </div>
          <ul v-else class="list-group list-group-flush">
            <li
              v-for="row in sepBreakdown.rows" :key="row.name"
              class="list-group-item d-flex align-items-center justify-content-between px-0"
            >
              <span>{{ row.name }}</span>
              <span class="badge badge-primary badge-pill">{{ row.y | numeral(0, 0) }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import InformalLga from "./informallga";
import BasicCategory from "./basicCategory";
import GenderbyLGA from "./GenderbyLGA";
import VulnerableByLGA from "./VulnerableByLGA";
// import genderCategoryInformal from "./genderCategoryInformal";
import EnrolleebyLGAandFacility from "./EnrolleebyLGAandFacility";
import ChartAboveAndBelow18 from "./ChartAboveAndBelow18";
import genderCategory from "./genderCategory";
import subProgramsJson from "@/json/sub_programs.json";
let agency = JSON.parse(localStorage.getItem("agency"));

export default {
  components: {
    GenderbyLGA,
    // genderCategoryInformal,
    InformalLga,
    BasicCategory,
    genderCategory,
    VulnerableByLGA,
    EnrolleebyLGAandFacility,
    ChartAboveAndBelow18,
  },

  data() {
    return {
      user: null,
      agency: agency,
      mydata: "",
      informaldata: "",
      auth_user: "",
      providers: "",
      sectors: [
        {
          name: "Basic Healthcare Provision Fund",
        },
        {
          name: "State Equity Program",
        },
      ],
      clients: "",
      total_clients: "",
      offlineclients: [],
      employees: "",
      plans: "",
      tpas: "",
      sepBreakdown: { open: false, loading: false, rows: [] },
    };
  },
  beforeMount() {

    this.agency = JSON.parse(localStorage.getItem("agency"));
    this.$batchGet(`/api/v1/auth/getinformalsectorenrollees/${agency.id}`)
      .then((response) => {
        this.informaldata = response.data;
        console.log(response);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  computed: {},

  methods: {
    openSepBreakdown() {
      this.sepBreakdown = { open: true, loading: true, rows: [] };
      const subPrograms = (subProgramsJson[agency.id] && subProgramsJson[agency.id]["Vulnerable Sponsored"]) || [];

      Promise.all(
        subPrograms.map((name) =>
          this.$batchGet(`/api/v1/auth/getUsersfilterparams`, {
              params: { agency_id: agency.id, sectorType: name, perPage: 1 },
            })
            .then((response) => ({
              name,
              y: (response.data && response.data.meta && response.data.meta.total_principal) || 0,
            }))
            .catch((error) => {
              console.error(error);
              return { name, y: 0 };
            })
        )
      ).then((rows) => {
        this.sepBreakdown.rows = rows;
        this.sepBreakdown.loading = false;
      });
    },
    closeSepBreakdown() {
      this.sepBreakdown.open = false;
    },
  },
  created() {},
};
</script>

<style scoped>
.sep-card { cursor: pointer; transition: box-shadow 0.15s, transform 0.15s; }
.sep-card:hover { box-shadow: 0 0.5rem 1rem rgba(0,0,0,0.1) !important; transform: translateY(-1px); }
.sep-modal-overlay {
  position: fixed; inset: 0; z-index: 1050;
  background: rgba(0,0,0,0.5);
  display: flex; align-items: center; justify-content: center; padding: 24px;
}
.sep-modal { width: 100%; max-width: 420px; max-height: 80vh; overflow-y: auto; }
</style>
